import React, { Component } from 'react';
import { css, jsx } from '@emotion/core';
import styled from '@emotion/styled';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
import { IoIosArrowDropleftCircle } from "react-icons/io";

import GraphicSectionMidsize from "./Sections/GraphicSectionMidsize";
import DetailsSecuritySolutionSecuDocu from "./SolutionDetails/SecuritySolutionSecuDocu/DetailsSecuritySolutionSecuDocu";
import DetailsEpsonCR from "./SolutionDetails/EpsonCR/DetailsEpsonCR";
import DetailsARSolution from "./SolutionDetails/ARSolution/DetailsARSolution";
import DetailsITinfraSolution from "./SolutionDetails/ITinfraSolution/DetailsITinfraSolution";
import DetailsHealthcareSolution from "./SolutionDetails/HealthcareSolution/DetailsHealthcareSolution";
import DetailsSecuritySolutionFireEye from "./SolutionDetails/SecuritySolutionFireEye/DetailsSecuritySolutionFireEye";

const DivBack = styled.div`
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 1000;
  color: #1976d2;
  font-size: 52px;
`;

//function Details() {
class Details extends Component {
  render() {
    let key = this.props.match.params.key;
    console.log(key);

    let data = [
      {
        key: "SecuritySolutionSecuDocu",
        bgImagePath: "/images/GraphicSection_server_one.jpeg",
        bgImageOffset: "0% 6%",
        subTitle: "Security Solution",
        mainTitle: "SecuDocu",
        keyWord: "Printed Data Loss Prevention",
      },
      {
        key: "EpsonCR",
        bgImagePath: "/images/GraphicSection_projector.jpeg",
        bgImageOffset: "0% 30%",
        subTitle: "EPSON CR",
        mainTitle: "Projector and Smart Glasses",
        keyWord: "Exceptional quality and high productivity",
      },
      {
        key: "ArSolution",
        bgImagePath: "/images/GraphicSection_ar.jpeg",
        bgImageOffset: "0% 20%",
        subTitle: "AR Solution",
        mainTitle: "Smart Factory",
        keyWord: "Industrial Augmented Reality",
      },
      {
        key: "ITInfraSolution",
        bgImagePath: "/images/GraphicSection_server_two.jpeg",
        bgImageOffset: "0% 85%",
        subTitle: "IT Infra Solution",
        mainTitle: "ORACLE Services",
        keyWord: "Highly automated and secure",
      },
      {
        key: "HealthcareSolution",
        bgImagePath: "/images/GraphicSection_healthcare.jpeg",
        bgImageOffset: "0% 20%",
        subTitle: "Healthcare Solution",
        mainTitle: "CarePatch",
        keyWord: "Measure body temperature for 24 hours",
      },
      {
        key: "SecuritySolutionFireEye",
        bgImagePath: "/images/GraphicSection_server_one.jpeg",
        bgImageOffset: "0% 20%",
        subTitle: "Security Solution",
        mainTitle: "FireEye",
        keyWord: "Centralize security operations with one platform",
      },
    ];

    let HeadSections = data.map((value,index,array) => {
      if (key == value.key) return <GraphicSectionMidsize key={value.key} info={value}/>;
    });

    let MainSection = [];
    switch(key) {
      case "SecuritySolutionSecuDocu":
        MainSection = <DetailsSecuritySolutionSecuDocu/>;
        break;
      case "EpsonCR":
        MainSection = <DetailsEpsonCR/>;
        break;
      case "ArSolution":
        MainSection = <DetailsARSolution/>;
        break;
      case "ITInfraSolution":
        MainSection = <DetailsITinfraSolution/>;
        break;
      case "HealthcareSolution":
        MainSection = <DetailsHealthcareSolution/>;
        break;
      case "SecuritySolutionFireEye":
        MainSection = <DetailsSecuritySolutionFireEye/>;
        break;
    }

    return (
      <div className="Details" style={{paddingTop:'56px'}}>
        {HeadSections}
        {MainSection}
        <Link to='/solutions'>
          <DivBack>
            <IoIosArrowDropleftCircle/>
          </DivBack>
        </Link>
      </div>
    );
  }
}

export default Details;
